import React from 'react';
import Header from './Header';
import Footer from './Footer'; // Importa o componente Footer real
import type { FooterData } from '@/types';

interface LayoutProps {
  children: React.ReactNode;
  footerData?: FooterData;
}

function Layout({ children, footerData }: LayoutProps) {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow w-full">
        {children}
      </main>
      <Footer data={footerData} />
    </div>
  );
}

export default Layout; 